export enum Snackbar {
    SHOW = '@snackbar/show',
    HIDE = '@snackbar/hide',
    SET_BOTTOM_MARGIN = '@snackbar/setBottomMargin',
    SET_Z_INDEX = '@snackbar/setZIndex',
}

export const SNACKBAR_CLOSE_TIMEOUT = 7000;
export const SNACKBAR_CLOSE_TIMEOUT_LOW = 3000;
